import { getNameById, objectValid } from '@/utils/public.js'

const type = {
  // 运行模式
  runModes: [
    { id: 0, name: '手动' },
    { id: 1, name: '自动' },
    { id: 2, name: '计划' },
    { id: 3, name: '事件触发' }
  ],
  // 同步方法
  synchMethods: [
    { id: 0, name: '完全同步' },
    { id: 1, name: '同步新增记录' },
    { id: 2, name: '同步修改记录' },
    { id: 3, name: '同步删除记录' }
  ],
  // 资源种类
  resourceKinds: [
    { id: 0, name: '监控设备' },
    { id: 21, name: '视频输入' },
    { id: 22, name: '信号量输入' },
    { id: 23, name: '模拟量输入' },
    { id: 24, name: '信号量输出' },
    { id: 25, name: '模拟量输出' },
    { id: 26, name: '语音' },
    { id: 31, name: '定位节点' },
    { id: 96, name: '人员' },
    { id: 97, name: '岗位' },
    { id: 98, name: '部门' },
    { id: 110, name: '车辆' },
    { id: 150, name: '区域' }
  ],
  // 视频对象种类
  streamObjectKinds: [
    { id: 0, name: '网络高速球' },
    { id: 1, name: '网络中速球' },
    { id: 2, name: '网络固定摄像机' },
    { id: 11, name: '红外热成像仪' },
    { id: 12, name: '网络半球摄像机' },
    { id: 13, name: '轨道机摄像机' },
    { id: 14, name: '高清全景摄像机' }
  ],
  // 信号量输入采集对象种类
  diGaugedObjectKinds: [
    { id: 0, name: '水浸' },
    { id: 1, name: '红外对射' },
    { id: 2, name: '红外双鉴' },
    { id: 3, name: '电子围栏' },
    { id: 4, name: '烟感' },
    { id: 5, name: '门' },
    { id: 6, name: '消防' },
    { id: 10, name: '求助' },
    { id: 11, name: '排风机' },
    { id: 12, name: '空调' },
    { id: 13, name: '开关' },
    { id: 14, name: '运行状态' },
    { id: 15, name: '陀螺仪' },
    { id: 16, name: '电扇' },
    { id: 17, name: '除湿器' },
    { id: 18, name: '水泵' },
    { id: 19, name: '电视' },
    { id: 50, name: '道闸' },
    { id: 254, name: '其他信号量' }
  ],
  // 模拟量输入采集对象种类
  aiGaugedObjectKinds: [
    { id: 0, name: '温度' },
    { id: 1, name: '湿度' },
    { id: 2, name: '浓度' },
    { id: 3, name: '速度' },
    { id: 4, name: '电流' },
    { id: 5, name: '电压' },
    { id: 6, name: '功率' },
    { id: 7, name: '频率' },
    { id: 8, name: '负载率' },
    { id: 9, name: '压力' },
    { id: 10, name: '耗时' },
    { id: 11, name: '距离' },
    { id: 12, name: '重量' },
    { id: 13, name: '数量' },
    { id: 14, name: '密度' },
    { id: 15, name: '液位' },
    { id: 16, name: '次数' },
    { id: 40, name: '工作模式' },
    { id: 254, name: '其他模拟量' }
  ],
  // 信号量控制对象种类
  doControlledObjectKinds: [
    { id: 0, name: '灯光照明' },
    { id: 1, name: '声光报警' },
    { id: 2, name: '警笛' },
    { id: 3, name: '空调' },
    { id: 4, name: '开关' },
    { id: 12, name: '电扇' },
    { id: 13, name: '除湿器' },
    { id: 14, name: '水泵' },
    { id: 15, name: '排风机' },
    { id: 16, name: '电视' },
    { id: 20, name: '门' },
    { id: 50, name: '道闸' },
    { id: 254, name: '其他信号量' }
  ],
  // 模拟量控制对象种类
  aoControlledObjectKinds: [
    { id: 0, name: '温度' },
    { id: 1, name: '湿度' },
    { id: 40, name: '工作模式' },
    { id: 254, name: '其他模拟量' }
  ],
  // 车辆种类
  vehicleKinds: [
    { id: 0, name: '小型车' },
    { id: 2, name: '大型车' },
    { id: 254, name: '其他' }
  ],
  // 日志类型
  logTypes: [
    { id: 1, name: '操作日志' },
    { id: 2, name: '系统日志' },
    { id: 3, name: '远程日志' }
  ],
  // 日志子类型
  operationLogTypes: [
    { id: 1, name: '实时视频' },
    { id: 2, name: '音频侦听' },
    { id: 3, name: '抓拍' },
    { id: 4, name: '云台控制' },
    { id: 5, name: '预置点' },
    { id: 6, name: '视频参数' },
    { id: 7, name: '视频轮巡' },
    { id: 8, name: '录像' },
    { id: 51, name: '回放' },
    { id: 51, name: '下载' },
    { id: 52, name: '回放' },
    { id: 101, name: '电子地图' },
    { id: 151, name: '输出控制' },
    { id: 201, name: '对讲' },
    { id: 251, name: '告警控制' },
    { id: 301, name: '图片浏览' },
    { id: 451, name: '本地配置' },
    { id: 452, name: '用户管理' },
    { id: 453, name: '设备管理' },
    { id: 454, name: '版本管理' },
    { id: 455, name: '数据库管理' },
    { id: 460, name: '人员管理' },
    { id: 461, name: '车辆管理' },
    { id: 462, name: '服务器管理' },
    { id: 470, name: '录像管理' },
    { id: 471, name: '抓拍管理' },
    { id: 480, name: '告警管理' },
    { id: 481, name: '时间管理' },
    { id: 482, name: '运维管理' },
    { id: 483, name: '日志管理' },
    { id: 484, name: '计划管理' }
  ],
  // 系统日志类型
  systemLogTypes: [
    { id: 1, name: '系统事件' },
    { id: 2, name: '系统异常' },
    { id: 501, name: '用户登录' }
  ],
  // 远程日志类型
  remoteLogTypes: [
    { id: 1, name: '报警日志' },
    { id: 2, name: '异常日志' },
    { id: 3, name: '操作日志' },
    { id: 4, name: '信息日志' }
  ],
  /*****************************************************************************************************************/
  // 事件相关
  /*****************************************************************************************************************/
  // 告警状态
  alarmStates: [
    { id: 0, name: '正常' },
    { id: 1, name: '告警' },
    { id: 2, name: '未知' }
  ],
  // 告警级别
  alarmLevels: [
    { id: 0, name: '事项' },
    { id: 1, name: '普通告警' },
    { id: 2, name: '重要告警' },
    { id: 3, name: '紧急告警' }
  ],
  // 确认状态
  handleStates: [
    { id: 0, name: '未确认' },
    { id: 1, name: '已确认' }
  ],
  encoderEventTypes: [
    { id: 0, name: '无' },
    { id: 1, name: '设备离线或故障' },
    { id: 2, name: '磁盘满告警' },
    { id: 4, name: '磁盘出错告警' },
    { id: 8, name: '磁盘没有格式化' },
    { id: 0x10, name: 'CPU占用率过高' },
    { id: 0x20, name: '内存占用率过高' },
    { id: 0x40, name: '网络流量过大' },
    { id: 0x80, name: '欠压' },
    { id: 0x100, name: '过压' },
    { id: 0x200, name: '掉电' },
    { id: 0x400, name: '欠相' },
    { id: 0x800, name: '逆相' },
    { id: 0x1000, name: '频率异常' },
    { id: 0x2000, name: '设备拆除' },
    { id: 0x4000, name: '短路' },
    { id: 0x8000, name: '地址冲突' },
    { id: 0x10000, name: '信号量输入报警' },
    { id: 0x20000, name: '模拟量输入报警' },
    { id: 0x40000, name: '视频输入报警' },
    { id: 0x80000, name: '定位报警' },
    { id: 0x100000, name: '设备重启' },
    { id: 0x200000, name: '语音报警' }
  ],
  videoEventTypes: [
    { id: 0, name: '无' },
    { id: 1, name: '视频遮挡' },
    { id: 2, name: '视频丢失' },
    { id: 4, name: '视频移动侦测' },
    { id: 8, name: '智能视频分析' },
    { id: 16, name: '视频诊断异常' },
    { id: 32, name: '设备故障报警' },
    { id: 0x10000000, name: '交通违章检测' }
  ],
  videoTrafficViolationEventTypes: [
    { id: 0, name: '无' },
    { id: 1, name: '未违章' },
    { id: 2, name: '违停' },
    { id: 4, name: '逆行' },
    { id: 8, name: '压线' },
    { id: 16, name: '变道' },
    { id: 32, name: '占道' },
    { id: 64, name: '掉头' },
    { id: 128, name: '超速' },
    { id: 0x0100000, name: '打电话' },
    { id: 0x0200000, name: '未带安全带' },
    { id: 0x8000000, name: '其他' }
  ],
  // 通行方向，0-上行，1-下行，3-双向，4-由东到西，5-由南到北，6-由西到东，7-由北到南，254-其他
  viTrafficDirections: [
    { id: 0, name: '上行' },
    { id: 1, name: '下行' },
    { id: 3, name: '双向' },
    { id: 4, name: '由东到西' },
    { id: 5, name: '由南到北' },
    { id: 6, name: '由西到东' },
    { id: 7, name: '由北到南' },
    { id: 254, name: '其他' }
  ],
  diEventTypes: [
    { id: 0, name: '无' },
    { id: 1, name: '状态变化' },
    { id: 2, name: '状态报警' },
    { id: 4, name: '设备离线或故障' },
    { id: 8, name: '低电压' },
    { id: 16, name: '设备拆除' },
    { id: 32, name: '短路报警' },
    { id: 64, name: '开路报警' },
    { id: 128, name: '未系安全带' }
  ],
  diDoorEventTypes: [
    { id: 0, name: '无' },
    { id: 1, name: '正常门开关' },
    { id: 2, name: '超时未关门' },
    { id: 4, name: '非法开门' }
  ],
  diDoorOperations: [
    { id: 0, name: '无' },
    { id: 1, name: '开门' },
    { id: 2, name: '关门' },
    { id: 4, name: '强制开门' },
    { id: 5, name: '远程开门' },
    { id: 6, name: '密码开门' },
    { id: 7, name: '胁迫码开门' },
    { id: 8, name: '自定义输入开门' },
    { id: 9, name: '按扭开门' },
    { id: 10, name: '远程关门' },
    { id: 11, name: '紧急开门' },
    { id: 12, name: '紧急关门' },
    { id: 13, name: '强制关门' },
    { id: 14, name: '取消强制关门' },
    { id: 15, name: '按扭关门' },
    { id: 16, name: '刷卡开门' },
    { id: 17, name: '未授权卡' },
    { id: 18, name: '卡过期' },
    { id: 19, name: '错误密码' },
    { id: 20, name: '违反反潜回规则' },
    { id: 21, name: '违反互锁规则' },
    { id: 22, name: '门常闭' },
    { id: 23, name: '违反多卡开门规则' },
    { id: 24, name: '违反首卡开门规则' },
    { id: 30, name: '系统故障' },
    { id: 31, name: '门开超时' },
    { id: 254, name: '未知故障' }
  ],
  diDirections: [
    { id: 0, name: '未知' },
    { id: 1, name: '进' },
    { id: 2, name: '出' }
  ],
  diLetPasss: [
    { id: 0, name: '未知' },
    { id: 1, name: '放行' },
    { id: 2, name: '未放行' }
  ],
  aiEventTypes: [
    { id: 0, name: '无' },
    { id: 1, name: '状态变化' },
    { id: 2, name: '超下限' },
    { id: 4, name: '超上限' },
    { id: 8, name: '超下下限' },
    { id: 16, name: '超上上限' },
    { id: 32, name: '设备故障报警' },
    { id: 64, name: '低电压报警' },
    { id: 128, name: '拆除报警' },
    { id: 1024, name: '升温过快' }
  ],
  /*****************************************************************************************************************/
  // 视频相关
  /*****************************************************************************************************************/
  // 流打开模式
  streamOpenModes: [
    { id: 0, name: '主码流' },
    { id: 1, name: '辅码流1' },
    { id: 2, name: '辅码流2' },
    { id: 3, name: '辅码流3' },
    { id: 11, name: '主+辅1码流' },
    { id: 12, name: '主+辅2码流' },
    { id: 13, name: '主+辅3码流' },
    { id: 255, name: '由视频节点决定' }
  ],
  /*****************************************************************************************************************/
  // 录像相关
  /*****************************************************************************************************************/
  // 录像方式
  recordMethods: [
    { id: 0, name: '本地录像' },
    { id: 1, name: '远程录像' }
  ],
  // 录像文件类型
  recordFileTypes: [
    { id: 0, name: '全部' },
    { id: 1, name: '定时录像' },
    { id: 2, name: '报警录像' },
    { id: 3, name: '手动录像' }
  ],
  // 录像类型
  recordFileEventTypes: [
    { id: 0, name: '全部' },
    { id: 0x10, name: '信号量报警' },
    { id: 0x11, name: '模拟量报警' },
    { id: 0x20, name: '视频丢失报警' },
    { id: 0x21, name: '视频遮挡报警' },
    { id: 0x22, name: '动态侦测' },
    { id: 0x30, name: '智能分析' }
  ],
  // 录像状态
  recordStates: [
    { id: 0, name: '未知' },
    { id: 1, name: '停止' },
    { id: 2, name: '录像中' },
    { id: 3, name: '录像异常' }
  ],
  // 录像文件格式
  recordFileFormats: [
    { id: 0, name: '原始流' },
    { id: 1, name: '自定义' },
    { id: 2, name: 'mp4' },
    { id: 3, name: 'flv' },
    { id: 4, name: '其他' }
  ],
  // 录像任务适用范围
  recordTaskScopes: [
    { id: 0, name: '关联视频节点' },
    { id: 1, name: '全部' }
  ],
  /*****************************************************************************************************************/
  // 抓拍相关
  /*****************************************************************************************************************/
  // 抓拍方式
  captureMethods: [
    { id: 0, name: '远程抓图' },
    { id: 1, name: '本地抓图' }
  ],
  // 图片格式
  pictureFormats: [
    { id: 0, name: 'bmp' },
    { id: 1, name: 'jpg' },
    { id: 2, name: 'png' },
    { id: 254, name: '其他' }
  ],
  // 抓拍任务适用范围
  captureTaskScopes: [
    { id: 0, name: '关联视频节点' },
    { id: 1, name: '全部' }
  ],
  /*****************************************************************************************************************/
  // 设备控制相关
  /*****************************************************************************************************************/
  // PTZ命令
  ptzCommands: {
    DVR_PTZ_MOVE_DOWN: 0x0302, // 下
    DVR_PTZ_MOVE_UP: 0x0301, // 上
    DVR_PTZ_MOVE_LEFT: 0x0303, // 左
    DVR_PTZ_MOVE_RIGHT: 0x0304, // 右
    DVR_PTZ_STOP_UP: 0x0305, // 停止上
    DVR_PTZ_STOP_DOWN: 0x0306, // 停止下
    DVR_PTZ_STOP_LEFT: 0x0307, // 停止左
    DVR_PTZ_STOP_RIGHT: 0x0308, // 停止右

    DVR_PTZ_MOVE_LEFTUP: 0x0401, // 移动左上
    DVR_PTZ_MOVE_LEFTDOWN: 0x0402, // 移动左下
    DVR_PTZ_MOVE_RIGHTUP: 0x0403, // 移动左上
    DVR_PTZ_MOVE_RIGHTDOWN: 0x0404, // 移动右下
    DVR_PTZ_STOP_LEFTUP: 0x0405, // 停止左上
    DVR_PTZ_STOP_LEFTDOWN: 0x0406, // 停止左下
    DVR_PTZ_STOP_RIGHTUP: 0x0407, // 停止左上
    DVR_PTZ_STOP_RIGHTDOWN: 0x0408, // 停止右下

    DVR_PTZ_ZOOM_IN: 0x0501, // 放大
    DVR_PTZ_ZOOM_OUT: 0x0502, // 缩小
    DVR_PTZ_STOP_ZOOM_IN: 0x0503, // 停止放大
    DVR_PTZ_STOP_ZOOM_OUT: 0x0504, // 停止缩小

    DVR_PTZ_FOCUS_IN: 0x0601, // 拉远
    DVR_PTZ_FOCUS_OUT: 0x0602, // 拉近
    DVR_PTZ_STOP_FOCUS_IN: 0x0603, // 停止拉远
    DVR_PTZ_STOP_FOCUS_OUT: 0x0604, // 停止拉近

    DVR_PTZ_APERTURE_INCREASE: 0x0901, // 光圈放大
    DVR_PTZ_APERTURE_DECREASE: 0x0902, // 光圈缩小
    DVR_PTZ_APERTURE_STOP_INCREASE: 0x0903, // 停止光圈放大
    DVR_PTZ_APERTURE_STOP_DECREASE: 0x0904, // 停止光圈缩小

    DVR_PTZ_MOVE_PRESET: 0x1201, // 调用预置点
    DVR_PTZ_SET_PRESET: 0x1202, // 设置预置点
    DVR_PTZ_DEL_PRESET: 0x1203 // 删除预置点
  },
  /*****************************************************************************************************************/
  // 其他相关
  /*****************************************************************************************************************/
  // 密级程度
  secrecys: [
    {id: 0, name: '不涉密'},
    {id: 1, name: '涉密'}
  ],
  // 注册方式
  registerWays: [
    {id: 0, name: 'sip3261标准'},
    {id: 1, name: '口令'},
    {id: 2, name: '数字证书'}
  ],
  // 信令安全模式
  safetyWays: [
    {id: 0, name: '不采用'},
    {id: 1, name: 'S/MIME 签名方式'},
    {id: 2, name: 'S/MIME 加密签名方式'},
    {id: 3, name: '数字摘要方式'}
  ],
  // 室内室外
  roomTypes: [
    {id: 0, name: '未使用'},
    {id: 1, name: '室外'},
    {id: 2, name: '室内'}
  ],
  // 安装位置类型
  positionTypes: [
    { id: 0, name: '未使用' },
    { id: 1, name: '省际检查站' },
    { id: 2, name: '党政机关' },
    { id: 3, name: '车站码头' },
    { id: 4, name: '中心广场' },
    { id: 5, name: '体育场馆' },
    { id: 6, name: '商业中心' },
    { id: 7, name: '宗教场所' },
    { id: 8, name: '校园周边' },
    { id: 9, name: '治安复杂区域' },
    { id: 10, name: '交通干线' }
  ],
  // 用途
  useTypes: [
    { id: 0, name: '未使用' },
    { id: 1, name: '治安' },
    { id: 2, name: '交通' },
    { id: 3, name: '重点' }
  ],
  // 建档状态
  archiveStatuss: [
    { id: 0, name: '未完善' },
    { id: 1, name: '部分完善' },
    { id: 2, name: '基本完善' },
    { id: 3, name: '全部完善' }
  ],
  // 行业
  industries: [
    { id: 999999, name: '社会治安路面' },
    { id: 1999999, name: '社会治安社区' },
    { id: 2999999, name: '社会治安内部' },
    { id: 3999999, name: '社会治安其他' },
    { id: 4999999, name: '交通路面' },
    { id: 5999999, name: '交通卡口' },
    { id: 6999999, name: '交通内部' },
    { id: 7999999, name: '交通其他' },
    { id: 8999999, name: '城市管理' },
    { id: 9999999, name: '卫生环保' },
    { id: 10999999, name: '商检海关' },
    { id: 11999999, name: '教育' },
    { id: 40999999, name: '农林牧渔' },
    { id: 41999999, name: '采矿' },
    { id: 42999999, name: '制造' },
    { id: 43999999, name: '冶金' },
    { id: 44999999, name: '电力' },
    { id: 45999999, name: '燃气' },
    { id: 4699999, name: '建筑' },
    { id: 4799999, name: '物流' },
    { id: 4899999, name: '邮政' },
    { id: 4999999, name: '信息' },
    { id: 5099999, name: '住宿餐饮' },
    { id: 5199999, name: '金融' },
    { id: 5299999, name: '房地产' },
    { id: 5399999, name: '商业服务' },
    { id: 5499999, name: '水利' },
    { id: 5599999, name: '娱乐' },
    { id: 8099999, name: '居民自建' },
    { id: 9099999, name: '其他' }
  ],
  // 函数列表
  // 返回资源子类型名称
  getResourceSubTypeNameById: function (resourceKind, id) {
    if (resourceKind === 22) {
      return getNameById(id, this.diGaugedObjectKinds)
    } else if (resourceKind === 23) {
      return getNameById(id, this.aiGaugedObjectKinds)
    } else if (resourceKind === 24) {
      return getNameById(id, this.doControlledObjectKinds)
    } else if (resourceKind === 25) {
      return getNameById(id, this.aoControlledObjectKinds)
    } else {
      return '未知'
    }
  },
  // 返回事件类型名称
  getEventTypeNameById: function (resourceKind, id) {
    if (resourceKind === 0) {
      return getNameById(id, this.encoderEventTypes)
    } if (resourceKind === 21) {
      return getNameById(id, this.videoEventTypes)
    } if (resourceKind === 22) {
      return getNameById(id, this.diEventTypes)
    } else if (resourceKind === 23) {
      return getNameById(id, this.aiEventTypes)
    } else {
      return '未知'
    }
  },
  // 返回事件子类型名称
  getEventSubTypeNameById: function (resourceKind, resourceSubType, eventType, id) {
    if (resourceKind === 22) {
      if (resourceSubType === 5) { // 门
        return getNameById(id, this.diDoorEventTypes)
      } else {
        return getNameById(id, this.diEventTypes)
      }
    } else if (resourceKind === 23) {
      return getNameById(id, this.aiEventTypes)
    } else {
      return '未知'
    }
  },
  // 返回资源告警状态文本
  getResourceAlarmStateText: function (resourceKind, alarmState, eventType, deployed, encoderAlarmState, encoderEventType) {
    if (!deployed) {
      return '撤防'
    }

    if (alarmState === 1) {
      if (resourceKind === 0) { // 监控设备
        if (eventType === 0x01) {
          return '离线'
        } else {
          return '告警'
        }
      } else if (resourceKind === 21) { // 视频节点
        if (eventType === 0x20) {
          return '离线'
        } else {
          return '告警'
        }
      } else if (resourceKind === 22) { // 信号量输入
        if (eventType === 0x04) {
          return '离线'
        } else {
          return '告警'
        }
      } else if (resourceKind === 23) { // 模拟量输入
        if (eventType === 0x20) {
          return '离线'
        } else {
          return '告警'
        }
      } else if (resourceKind === 31) { // 定位节点
        if (eventType === 0x40) {
          return '离线'
        } else {
          return '告警'
        }
      } else {
        return '告警'
      }
    } else if (alarmState === 0) {
      if (resourceKind === 0) { // 监控设备
        return '正常'
      } else {
        return this.getResourceOnlineState(0, encoderAlarmState, encoderEventType, 0, 0) === 1 ? '正常' : '离线'
      }
    } else {
      return '未知'
    }
  },
  // 返回资源告警状态
  getResourceAlarmState: function (resourceKind, alarmState, encoderAlarmState, encoderEventType) {
    if (alarmState === 1) {
      return 1
    } else if (alarmState === 0) {
      if (resourceKind === 0) { // 监控设备
        return 0
      } else {
        return this.getResourceOnlineState(0, encoderAlarmState, encoderEventType, 0, 0) === 1 ? 0 : 1
      }
    } else {
      return 2
    }
  },
  // 返回资源在线状态
  getResourceOnlineState: function (resourceKind, alarmState, eventType, encoderAlarmState, encoderEventType) {
    if (alarmState === 1) {
      if (resourceKind === 0) { // 监控设备
        if (eventType === 0x01) {
          return 0
        } else {
          return 1
        }
      } else if (resourceKind === 21) { // 视频节点
        if (eventType === 0x20) {
          return 0
        } else {
          return this.getResourceOnlineState(0, encoderAlarmState, encoderEventType, 0, 0)
        }
      } else if (resourceKind === 22) { // 信号量输入
        if (eventType === 0x04) {
          return 0
        } else {
          return this.getResourceOnlineState(0, encoderAlarmState, encoderEventType, 0, 0)
        }
      } else if (resourceKind === 23) { // 模拟量输入
        if (eventType === 0x20) {
          return 0
        } else {
          return this.getResourceOnlineState(0, encoderAlarmState, encoderEventType, 0, 0)
        }
      } else if (resourceKind === 31) { // 定位节点
        if (eventType === 0x40) {
          return 0
        } else {
          return this.getResourceOnlineState(0, encoderAlarmState, encoderEventType, 0, 0)
        }
      } else {
        return this.getResourceOnlineState(0, encoderAlarmState, encoderEventType, 0, 0)
      }
    } else if (alarmState === 0) {
      if (resourceKind === 0) { // 监控设备
        return 1
      } else {
        return this.getResourceOnlineState(0, encoderAlarmState, encoderEventType, 0, 0)
      }
    } else {
      return this.getResourceOnlineState(0, encoderAlarmState, encoderEventType, 0, 0)
    }
  },
  // 返回资源工作状态
  getResourceWorkState: function (resourceKind, resourceSubType, gaugedValue, realValue, scaleFactor, correctedValue, valueType, decimalDigit) {
    if (resourceKind === 22) { // 信号量输入
      if (valueType === 0) { // 常开
        return Math.round(gaugedValue) === 1 ? 1 : 0
      } else if (valueType === 1) { // 常闭
        return Math.round(gaugedValue) === 0 ? 1 : 0
      } else {
        return Math.round(gaugedValue)
      }
    } else if (resourceKind === 23) { // 模拟量输入
      if (realValue) {
        if (isNaN(realValue)) {
          return realValue
        }
        return parseFloat(realValue).toFixed(decimalDigit)
      } else {
        if (isNaN(realValue)) {
          return realValue
        }

        if (!scaleFactor || Math.abs(scaleFactor) < 1e-15) {
          scaleFactor = 1.0
        }
        if (!correctedValue) {
          correctedValue = 0.0
        }

        if (valueType === 0) { // 实际值
          realValue = gaugedValue * scaleFactor + correctedValue
        } else {
          return realValue
        }
        return parseFloat(realValue).toFixed(decimalDigit)
      }
    } else {
      return gaugedValue
    }
  },
  // 返回资源工作状态文本
  getResourceWorkStateText: function (resourceKind, resourceSubType, gaugedValue, realValue, scaleFactor, correctedValue, valueType, decimalDigit, dataUnit) {
    if (resourceKind === 22) { // 信号量输入
      if (resourceSubType === 11 || resourceSubType === 12 || resourceSubType === 14 ||
        resourceSubType === 15 || resourceSubType === 17 || resourceSubType === 18 ||
        resourceSubType === 19) {
        if (valueType === 0) { // 常开
          return Math.round(gaugedValue) === 1 ? '运行' : '停止'
        } else if (valueType === 1) { // 常闭
          return Math.round(gaugedValue) === 0 ? '运行' : '停止'
        } else {
          return '类型未设置'
        }
      } else if (resourceSubType === 5 || resourceSubType === 13 || resourceSubType === 50) { // 开关
        if (valueType === 0) { // 常开
          return Math.round(gaugedValue) === 1 ? '打开' : '关闭'
        } else if (valueType === 1) { // 常闭
          return Math.round(gaugedValue) === 0 ? '打开' : '关闭'
        } else {
          return '类型未设置'
        }
      } else if (resourceSubType === 9) { // 告警状态
        if (valueType === 0) { // 常开
          return Math.round(gaugedValue) === 1 ? '告警' : '正常'
        } else if (valueType === 1) { // 常闭
          return Math.round(gaugedValue) === 0 ? '告警' : '正常'
        } else {
          return '类型未设置'
        }
      } else if (resourceSubType === 253) { // 配置参数
        if (valueType === 0) { // 常开
          return Math.round(gaugedValue) === 1 ? '启用' : '禁用'
        } else if (valueType === 1) { // 常闭
          return Math.round(gaugedValue) === 0 ? '启用' : '禁用'
        } else {
          return '类型未设置'
        }
      } else {
        return Math.round(gaugedValue) === 1 ? '闭合' : '分开'
      }
    } else if (resourceKind === 23) { // 模拟量输入
      if (realValue) {
        if (isNaN(realValue) || Math.abs(realValue) >= 300000000 - 100) {
          return '无效'
        }
        return parseFloat(realValue).toFixed(decimalDigit) + dataUnit
      } else {
        if (realValue) {
          if (isNaN(realValue) || Math.abs(realValue) >= 300000000 - 100) {
            return '无效'
          }
        } else {
          if (isNaN(gaugedValue) || Math.abs(gaugedValue) >= 300000000 - 100) {
            return '无效'
          }

          if (!scaleFactor || Math.abs(scaleFactor) < 1e-15) {
            scaleFactor = 1.0
          }
          if (!correctedValue) {
            correctedValue = 0.0
          }

          if (valueType === 0) { // 实际值
            realValue = gaugedValue * scaleFactor + correctedValue
          } else {
            return '不支持'
          }
        }

        if (resourceSubType === 40) { // 空调模式
          if (parseInt(realValue) === 0) {
            return '自动'
          } else if (parseInt(realValue) === 1) {
            return '制冷'
          } else if (parseInt(realValue) === 2) {
            return '制热'
          } else if (parseInt(realValue) === 3) {
            return '除湿'
          } else if (parseInt(realValue) === 4) {
            return '送风'
          }
        } else if (resourceSubType === 42) { // 空调风速
          if (parseInt(realValue) === 0) {
            return '弱风'
          } else if (parseInt(realValue) === 1) {
            return '中风'
          } else if (parseInt(realValue) === 2) {
            return '强风'
          }
        } else if (resourceSubType === 45) { // 除湿机模式
          if (parseInt(realValue) === 0) {
            return '自动'
          } else if (parseInt(realValue) === 1) {
            return '制冷'
          } else if (parseInt(realValue) === 3) {
            return '除湿'
          } else if (parseInt(realValue) === 4) {
            return '送风'
          }
        }

        return parseFloat(realValue).toFixed(decimalDigit) + dataUnit
      }
    } else {
      return '未知'
    }
  },
  // 返回数据节点告警等级
  getDataNodeAlarmLevel(obj) {
    if (obj.resourceKind === 22) { // 信号量输入
      if (obj.gaugedObjectKind === 12 ||
        obj.gaugedObjectKind === 11 ||
        obj.gaugedObjectKind === 16 ||
        obj.gaugedObjectKind === 18 ||
        obj.gaugedObjectKind === 17 ||
        obj.gaugedObjectKind === 19 ||
        obj.gaugedObjectKind === 14) { // 运行状态
        return 0
      } else if (obj.gaugedObjectKind === 5 || obj.gaugedObjectKind === 13 ||
        obj.gaugedObjectKind === 50) { // 开关
        return 0
      } else if (obj.gaugedObjectKind === 9) { // 告警状态
        return 1
      } else if (obj.gaugedObjectKind === 253) { // 设置
        return 0
      } else {
        return 1
      }
    } else if (obj.resourceKind === 23) { // 模拟量输入
      return 1
    } else {
      return 1
    }
  },
  // 返回数据节点告警规则文本
  getDataNodeAlarmRuleText(obj) {
    if (obj.resourceKind === 22) { // 信号量输入
      if (obj.diAlarmDetectionEnabled) {
        return obj.valueType === 0 ? '常开' : '常闭'
      } else {
        return '无'
      }
    } else if (obj.resourceKind === 23) { // 模拟量输入
      let alarmRuleText = '无'
      if (obj.alarmlimitEnabled) {
        alarmRuleText = '[' + obj.alarmLowLimit + ',' + obj.alarmHighLimit + ']'
      }
      if (obj.alarmLimit2Enabled) {
        if (obj.alarmlimitEnabled) {
          alarmRuleText += ','
        } else {
          alarmRuleText = ''
        }
        alarmRuleText += '[' + obj.alarmLowLimit2 + ',' + obj.alarmHighLimit2 + ']'
      }
      return alarmRuleText
    } else {
      return '无'
    }
  },
  // 根据资源控制数值返回控制状态
  getResourceControlState: function (resourceKind, controlValue, valueType) {
    if (resourceKind === 24) { // 信号量输出
      if (valueType === 0) { // 0-值1为打开设备,1-值0为打开设备
        return controlValue === 1 ? 1 : 0
      } else if (valueType === 1) {
        return controlValue === 0 ? 1 : 0
      } else {
        return 0
      }
    } else if (resourceKind === 25) { // 模拟量输出
      return controlValue
    } else {
      return 0
    }
  },
  // 根据资源控制数值返回控制状态文本
  getResourceControlStateText: function (resourceKind, resourceSubType, controlValue, valueType, decimalDigit, dataUnit) {
    if (resourceKind === 24) { // 信号量输出
      if (valueType === 0) { // 0-值1为打开设备,1-值0为打开设备
        return parseInt(controlValue) === 1 ? '打开' : '关闭'
      } else if (valueType === 1) {
        return parseInt(controlValue) === 0 ? '打开' : '关闭'
      } else {
        return '关闭'
      }
    } else if (resourceKind === 25) { // 模拟量输出
      if (isNaN(controlValue) || Math.abs(controlValue) >= 300000000 - 100) {
        return '无效'
      }

      if (resourceSubType === 60) { // 空调模式
        if (parseInt(controlValue) === 0) {
          return '自动'
        } else if (parseInt(controlValue) === 1) {
          return '制冷'
        } else if (parseInt(controlValue) === 2) {
          return '制热'
        } else if (parseInt(controlValue) === 3) {
          return '除湿'
        } else if (parseInt(controlValue) === 4) {
          return '送风'
        }
      } else if (resourceSubType === 62) { // 空调风速
        if (parseInt(controlValue) === 0) {
          return '弱风'
        } else if (parseInt(controlValue) === 1) {
          return '中风'
        } else if (parseInt(controlValue) === 2) {
          return '强风'
        }
      } else if (resourceSubType === 65) { // 除湿机模式
        if (parseInt(controlValue) === 0) {
          return '自动'
        } else if (parseInt(controlValue) === 1) {
          return '制冷'
        } else if (parseInt(controlValue) === 3) {
          return '除湿'
        } else if (parseInt(controlValue) === 4) {
          return '送风'
        }
      }

      return parseFloat(controlValue).toFixed(objectValid(decimalDigit) ? decimalDigit : 2) + (objectValid(dataUnit) ? dataUnit : '')
    } else {
      return '未知'
    }
  }
}

export default type



// WEBPACK FOOTER //
// ./src/api/type.js